import { render, staticRenderFns } from "./IconClock.vue?vue&type=template&id=b2c5b1e6&scoped=true&"
import script from "./IconClock.vue?vue&type=script&lang=js&"
export * from "./IconClock.vue?vue&type=script&lang=js&"
import style0 from "./IconClock.vue?vue&type=style&index=0&id=b2c5b1e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c5b1e6",
  null
  
)

export default component.exports